import { render, staticRenderFns } from "./transRecord.vue?vue&type=template&id=d4fc66fa&scoped=true"
import script from "./transRecord.vue?vue&type=script&lang=js"
export * from "./transRecord.vue?vue&type=script&lang=js"
import style0 from "./transRecord.vue?vue&type=style&index=0&id=d4fc66fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fc66fa",
  null
  
)

export default component.exports